import Vue from 'vue'
import VueMeta from 'vue-meta'
import VueI18n from 'vue-i18n'
import Vue2Editor from 'vue2-editor';

import {InertiaApp} from '@inertiajs/inertia-vue'

const app = document.getElementById('app');
const documentLang = document.documentElement.lang;
const locale = document.querySelector('meta[name=locale').content;
const moment = require('moment');
moment.locale(locale);

Vue.config.productionTip = false;
Vue.use(InertiaApp);
Vue.use(VueMeta);
Vue.use(VueI18n);
Vue.use(Vue2Editor);
Vue.use(require('vue-moment'), {
    moment
});

Vue.prototype.$route = (...args) => route(...args).url();

import messages from './Translations/messages';

const i18n = new VueI18n({
    locale: documentLang,
    messages,
});

Vue.mixin({methods: {route: window.route}});

window.EventBus = new Vue();

new Vue({
    metaInfo: {
        title: 'Loading…',
        titleTemplate: '%s | TOPAnimation Cloud',
    },
    i18n,
    render: h => h(InertiaApp, {
        props: {
            initialPage: JSON.parse(app.dataset.page),
            resolveComponent: name => import(`./Pages/${name}`).then(module => module.default),
        }
    }),
}).$mount(app);
